import React, { useState } from "react";

const WhitelistRequest = () => {
  const [formData, setFormData] = useState({
    minecraftName: "",
    discordTag: "",
    reason: "",
  });

  const [status, setStatus] = useState({ message: "", type: "" });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple client-side validation
    if (!formData.minecraftName.trim() || !formData.discordTag.trim() || !formData.reason.trim()) {
      setStatus({ message: "Please fill in all required fields.", type: "error" });
      return;
    }

    const webhookURL =
      "https://discord.com/api/webhooks/1375129290756329573/mES6Egqx77Piafa7k449s3Peijpp_7ya1qQiF-AysMv0ZN5gMbojggzivOdOiR18ZmXF";

    const embed = {
      embeds: [
        {
          title: "✅ New Whitelist Request",
          color: 0x43aa8b,
          fields: [
            { name: "Minecraft Username", value: formData.minecraftName },
            { name: "Discord Tag", value: formData.discordTag },
            { name: "Reason", value: formData.reason },
          ],
          footer: {
            text: "RixxyMC Whitelist Request",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(embed),
      });

      if (!response.ok) throw new Error("Failed to submit whitelist request");

      setStatus({ message: "✅ Whitelist request submitted successfully!", type: "success" });
      setFormData({ minecraftName: "", discordTag: "", reason: "" });
    } catch (error) {
      setStatus({ message: "❌ Submission failed. Please try again later.", type: "error" });
    }
  };

  return (
    <div className="container" style={{ maxWidth: 600, margin: "2rem auto", padding: "1.5rem", backgroundColor: "rgba(20, 20, 40, 0.85)", borderRadius: 12, color: "#f0f0f0", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      <h2 style={{ textAlign: "center", marginBottom: "1rem", background: "linear-gradient(90deg, #90be6d, #43aa8b)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", fontWeight: "900" }}>Whitelist Request</h2>
      <p>Request to join the server whitelist.</p>

      {status.message && (
        <div
          style={{
            marginBottom: "1rem",
            color: status.type === "success" ? "#4CAF50" : "#ff6b6b",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="minecraftName" style={{ display: "block", marginBottom: "0.5rem", fontWeight: "600" }}>
          Minecraft Username:
        </label>
        <input
          type="text"
          id="minecraftName"
          value={formData.minecraftName}
          onChange={handleChange}
          placeholder="Your Minecraft username"
          required
          style={inputStyle}
        />

        <label htmlFor="discordTag" style={{ display: "block", marginTop: "1rem", marginBottom: "0.5rem", fontWeight: "600" }}>
          Discord Tag (e.g. user#1234):
        </label>
        <input
          type="text"
          id="discordTag"
          value={formData.discordTag}
          onChange={handleChange}
          placeholder="Your Discord Tag"
          required
          style={inputStyle}
        />

        <label htmlFor="reason" style={{ display: "block", marginTop: "1rem", marginBottom: "0.5rem", fontWeight: "600" }}>
          Why do you want to join the whitelist?
        </label>
        <textarea
          id="reason"
          rows="4"
          value={formData.reason}
          onChange={handleChange}
          placeholder="Tell us why you want to join the whitelist"
          required
          style={textareaStyle}
        ></textarea>

        <button type="submit" style={buttonStyle}>
          Submit Request
        </button>
      </form>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "0.5rem 0.75rem",
  borderRadius: "6px",
  border: "1px solid #555",
  backgroundColor: "#222",
  color: "#eee",
  fontSize: "1rem",
};

const textareaStyle = {
  ...inputStyle,
  resize: "vertical",
};

const buttonStyle = {
  marginTop: "1.5rem",
  padding: "0.75rem",
  borderRadius: "8px",
  border: "none",
  background: "linear-gradient(90deg, #90be6d, #43aa8b)",
  color: "#fff",
  fontSize: "1.1rem",
  fontWeight: "700",
  cursor: "pointer",
  transition: "background 0.3s ease",
};

export default WhitelistRequest;
